<template>
  <div class="offline">
    <img class="offline-img" src="../../assets/nodata.png" alt="">
    <p class="offline-title">页面不存在</p>
    <p class="offline-desc">您访问的龙虎榜内容已下架</p>
    <div class="offline-actions">
      <a class="btn btn-primary" href="https://www.9fzt.com">返回首页</a>
      <a class="btn btn-secondary" href="https://www.9fzt.com/marketCenter/index.html">去行情中心</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DragonTigerOffline',
  created() {
    document.title = '页面不存在_九方智投'
  }
}
</script>

<style lang="stylus" scoped>
.offline
  min-height 100vh
  box-sizing border-box
  padding .8rem .24rem .4rem
  background #fff
  text-align center
.offline-img
  width 2.5rem
  height 1.53rem
  display block
  margin 0 auto
.offline-title
  margin-top .24rem
  font-size .18rem
  font-family PingFangSC-Medium, PingFang SC
  font-weight 500
  color #333
  line-height .25rem
.offline-desc
  margin-top .08rem
  font-size .14rem
  font-family PingFangSC-Regular, PingFang SC
  color #999
  line-height .2rem
.offline-actions
  margin-top .4rem
  display flex
  flex-direction column
  align-items center
.btn
  display block
  width 2.4rem
  height .4rem
  line-height .4rem
  border-radius .04rem
  font-size .15rem
  text-decoration none
  box-sizing border-box
.btn-primary
  background #c8161d
  color #fff
.btn-secondary
  margin-top .12rem
  background #fff
  color #c8161d
  border .01rem solid #c8161d
</style>
